import { useEffect, useState } from 'react';
import { MdCheckCircle, MdError, MdInfo } from 'react-icons/md';

export default function Toast({ message, type = 'info', onClose, duration = 5000 }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => onClose?.(), 300); // Wait for fade out animation
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  if (!isVisible) return null;

  const bgColor = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    info: 'bg-blue-500',
    warning: 'bg-yellow-500',
  }[type] || 'bg-blue-500';

  const icon = {
    success: <MdCheckCircle className="text-xl" />,
    error: <MdError className="text-xl" />,
    info: <MdInfo className="text-xl" />,
    warning: <MdInfo className="text-xl" />,
  }[type] || <MdInfo className="text-xl" />;

  return (
    <div className={`${bgColor} text-white px-6 py-4 rounded-lg shadow-xl flex items-center gap-3 min-w-[300px] max-w-md animate-slide-in`}>
      {icon}
      <p className="flex-1">{message}</p>
      <button
        onClick={() => {
          setIsVisible(false);
          setTimeout(() => onClose?.(), 300);
        }}
        className="ml-2 hover:bg-white/20 rounded-full p-1 transition-colors"
        aria-label="Close"
      >
        <span className="text-xl leading-none">&times;</span>
      </button>
    </div>
  );
}

